module.exports = __webpack_public_path__ + "img/Transmission assembly.9c76236f.jpg";